import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import React from "react";

// VFX: Carousel Swipe Hint
// Category: ui-elements · Tags: carousel, swipe, arrow, instagram, hint
export default function IgCarouselArrowSwipeHintLoop() {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  const t = (frame / durationInFrames) * Math.PI * 2;
  const slide = Math.sin(t) * 30;
  const pulse = interpolate(Math.sin(t * 2), [-1, 1], [0.7, 1]);
  return (
    <AbsoluteFill style={{ background: "transparent", justifyContent: "flex-end", alignItems: "center", paddingBottom: 200 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 24, opacity: pulse }}>
        <span style={{
          color: "#f8fafc", fontFamily: "Inter, sans-serif", fontSize: 36, fontWeight: 600,
          letterSpacing: 4, textTransform: "uppercase",
          textShadow: "0 2px 8px rgba(0,0,0,0.6)",
          transform: `translateX(${slide}px)`,
        }}>swipe</span>
        <svg width="80" height="48" viewBox="0 0 80 48" style={{ transform: `translateX(${slide * 1.5}px)` }}>
          <path d="M 8 24 L 60 24 M 50 12 L 64 24 L 50 36" stroke="#f8fafc" strokeWidth="4" fill="none"
            strokeLinecap="round" strokeLinejoin="round"
            style={{ filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.5))" }} />
        </svg>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
